<ng-template #dynaEditorTemplate>

    <div class="modal-header pt-2 pb-2 headerBackground">
        <h6 class="modal-title pull-left ">DynaEdit</h6>
        <button type="button " class="btn-close pull-right" aria-label="Close"
            (click)="modalRef.hide();closeDragulaModal()">
            
        </button>
    </div>

    <div class="modal-body"> 
        <app-cosy-dynaeditor-grid 
            *ngIf="(dynaIE['ie'].TypeDID == IE_TYPES.EntityList )" 
            [dynaEditorElement]="dynaIE"
            [(dynaItem)]="dynaItem"
            (saveDEData)="saveDynaEditorData($event)" >
        </app-cosy-dynaeditor-grid>
        <app-cosy-dynaeditor-entity
            *ngIf="(dynaIE['ie'].TypeDID == IE_TYPES.FormEntity )"
            [dynaEditorElement]="dynaIE"
            [(dynaItem)]="dynaItem"
            (saveDEData)="saveDynaEditorData($event)" >
        </app-cosy-dynaeditor-entity>
        <app-cosy-dynaeditor-formcontrol
            *ngIf="(dynaIE['ie'].TypeDID == IE_TYPES.ListUXController || dynaIE['ie'].TypeDID == IE_TYPES.UXController)"
            [dynaEditorElement]="dynaIE"
            [(dynaItem)]="dynaItem"
            (saveDEData)="saveDynaEditorData($event)" >
        </app-cosy-dynaeditor-formcontrol>
        <app-cosy-dynaeditor-wizard
            *ngIf="(dynaIE['ie'].TypeDID == IE_TYPES.Wizard)"
            [dynaEditorElement]="dynaIE"
            [(dynaItem)]="dynaItem"
            (saveDEData)="saveDynaEditorData($event)" >
        </app-cosy-dynaeditor-wizard>        

    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary btn-sm"
            (click)="saveDynaEditorData(null,'save');modalRef.hide();closeDragulaModal();">Save</button>
        <button class="btn btn-secondary btn-sm"
            (click)="saveDynaEditorData(null,'cancel');modalRef.hide();closeDragulaModal();">Cancel</button>
    </div>

</ng-template>